const FILL_COLORS = {
  grey: "FFD9D9D9",
  lemon: "FFFFFF99",
  gold: "FFFFF2CC",
};

function setCellsFont(sheet, cells, font) {
  cells.forEach((cell) => {
    sheet.getCell(cell).font = font;
  });
}

function setCellsFill(sheet, cells, argb) {
  cells.forEach((cell) => {
    sheet.getCell(cell).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb },
    };
  });
}

function setCellAlignments(sheet, alignmentsByCell) {
  Object.entries(alignmentsByCell).forEach(([cell, alignment]) => {
    sheet.getCell(cell).alignment = alignment;
  });
}

function setColumnWidths(sheet, widthsByColumn) {
  Object.entries(widthsByColumn).forEach(([column, width]) => {
    sheet.getColumn(Number(column)).width = width;
  });
}

function setRowHeights(sheet, heightsByRow) {
  Object.entries(heightsByRow).forEach(([row, height]) => {
    sheet.getRow(Number(row)).height = height;
  });
}

function mergeRanges(sheet, ranges) {
  ranges.forEach((range) => sheet.mergeCells(range));
}

function buildColumnRowRangeCells(columns, startRow, endRowInclusive) {
  const cells = [];
  for (let row = startRow; row <= endRowInclusive; row++) {
    columns.forEach((column) => {
      cells.push(`${column}${row}`);
    });
  }
  return cells;
}

function buildBorder(sides) {
  return Object.fromEntries(
    Object.entries(sides).map(([side, style]) => [side, { style }]),
  );
}

function setBorders(sheet, cellsWithBorders) {
  Object.entries(cellsWithBorders).forEach(([cell, border]) => {
    sheet.getCell(cell).border = buildBorder(border);
  });
}

function setRowRangeBorders(sheet, startRow, endRowInclusive, borderByColumn) {
  for (let row = startRow; row <= endRowInclusive; row++) {
    const borders = borderByColumn(row);
    Object.entries(borders).forEach(([column, sides]) => {
      sheet.getCell(`${column}${row}`).border = buildBorder(sides);
    });
  }
}

function setGroupedBorders(sheet, groupedBorders) {
  groupedBorders.forEach(({ border, cells }) => {
    cells.forEach((cell) => {
      sheet.getCell(cell).border = border;
    });
  });
}

export function formatAbbreviatedReturn(
  group_period_sheet,
  group_level_elections_sheet,
  uk_group_companies_sheet,
) {
  const group_bolds = [
    "B2",
    "B7",
    "B9",
    "B11",
    "B15",
    "B18",
    "B24",
    "B29",
    "B33",
    "B37",
    "B40",
    "B46",
    "C24",
    "C29",
  ];
  setCellsFont(group_period_sheet, group_bolds, { bold: true });
  mergeRanges(group_period_sheet, ["B35:D35", "B38:D38"]);

  setGroupedBorders(group_period_sheet, [
    {
      border: {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
      },
      cells: ["B2", "B7", "B9"],
    },
    {
      border: { top: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["C2", "C7", "C9"],
    },
    {
      border: {
        top: { style: "medium" },
        right: { style: "medium" },
        bottom: { style: "medium" },
      },
      cells: ["D2", "D7", "D9"],
    },
    {
      border: { top: { style: "medium" }, left: { style: "medium" } },
      cells: ["B4"],
    },
    { border: { top: { style: "medium" } }, cells: ["C4"] },
    {
      border: { top: { style: "medium" }, right: { style: "medium" } },
      cells: ["D4"],
    },
    {
      border: { left: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["B5"],
    },
    { border: { bottom: { style: "medium" } }, cells: ["C5"] },
    {
      border: { right: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["D5"],
    },
    {
      border: {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "thin" },
      },
      cells: ["B11", "B24", "B29", "B33", "B37", "B40", "B46"],
    },
    {
      border: { top: { style: "medium" }, bottom: { style: "thin" } },
      cells: ["C11", "C33", "C37", "C40"],
    },
    {
      border: {
        top: { style: "medium" },
        right: { style: "medium" },
        bottom: { style: "thin" },
      },
      cells: ["D11", "C24", "C29", "D33", "D37", "D40", "C46"],
    },
    {
      border: { left: { style: "medium" }, top: { style: "thin" } },
      cells: ["B12"],
    },
    { border: { top: { style: "thin" } }, cells: ["C12"] },
    {
      border: {
        top: { style: "thin" },
        right: { style: "medium" },
        bottom: { style: "thin" },
        left: { style: "thin" },
      },
      cells: ["D12"],
    },
    {
      border: { bottom: { style: "medium" }, left: { style: "medium" } },
      cells: ["B13", "B16"],
    },
    { border: { bottom: { style: "medium" } }, cells: ["C13"] },
    {
      border: {
        bottom: { style: "medium" },
        right: { style: "medium" },
        left: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["D13", "D16"],
    },
    {
      border: {
        top: { style: "medium" },
        left: { style: "medium" },
        right: { style: "thin" },
        bottom: { style: "thin" },
      },
      cells: ["B15", "B18"],
    },
    {
      border: {
        top: { style: "medium" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      cells: ["C15", "C18"],
    },
    {
      border: {
        top: { style: "medium" },
        right: { style: "medium" },
        left: { style: "thin" },
        bottom: { style: "thin" },
      },
      cells: ["D15", "D18"],
    },
    {
      border: {
        bottom: { style: "medium" },
        left: { style: "thin" },
        right: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["C16"],
    },
    {
      border: { left: { style: "medium" }, bottom: { style: "thin" } },
      cells: ["B21"],
    },
    {
      border: {
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["C21"],
    },
    {
      border: {
        bottom: { style: "medium" },
        left: { style: "thin" },
        right: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["C44"],
    },
    {
      border: {
        right: { style: "medium" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["D21"],
    },
    {
      border: {
        bottom: { style: "medium" },
        left: { style: "medium" },
        top: { style: "thin" },
      },
      cells: ["B27", "B47"],
    },
    {
      border: {
        bottom: { style: "medium" },
        left: { style: "medium" },
        top: { style: "thin" },
        right: { style: "thin" },
      },
      cells: ["B22"],
    },
    {
      border: {
        bottom: { style: "medium" },
        right: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["C22"],
    },
    {
      border: {
        bottom: { style: "medium" },
        right: { style: "medium" },
        left: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["D22", "D44"],
    },
    {
      border: {
        bottom: { style: "medium" },
        right: { style: "medium" },
        left: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["C27", "C47"],
    },
    {
      border: {
        left: { style: "medium" },
        right: { style: "thin" },
        bottom: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["B30"],
    },
    {
      border: {
        right: { style: "medium" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["C30"],
    },
    {
      border: {
        left: { style: "medium" },
        right: { style: "thin" },
        bottom: { style: "medium" },
        top: { style: "thin" },
      },
      cells: ["B31"],
    },
    {
      border: {
        right: { style: "medium" },
        bottom: { style: "medium" },
        left: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["C31"],
    },
    {
      border: {
        left: { style: "medium" },
        bottom: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["B34"],
    },
    {
      border: { bottom: { style: "thin" }, top: { style: "thin" } },
      cells: ["C34"],
    },
    {
      border: {
        right: { style: "medium" },
        bottom: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["D34"],
    },
    {
      border: {
        bottom: { style: "medium" },
        left: { style: "medium" },
        top: { style: "thin" },
        right: { style: "medium" },
      },
      cells: ["B35", "C35", "D35", "B38", "C38", "D38"],
    },
    {
      border: {
        left: { style: "medium" },
        right: { style: "thin" },
        bottom: { style: "medium" },
        top: { style: "thin" },
      },
      cells: ["B44"],
    },
  ]);
  setRowRangeBorders(group_period_sheet, 41, 43, () => ({
    B: { left: "medium", right: "thin", bottom: "thin", top: "thin" },
    C: { right: "thin", bottom: "thin", left: "thin", top: "thin" },
    D: { right: "medium", bottom: "thin", top: "thin", left: "thin" },
  }));
  setRowRangeBorders(group_period_sheet, 19, 20, () => ({
    B: { left: "medium", right: "thin" },
    C: { left: "thin", right: "thin" },
    D: { left: "thin", right: "medium" },
  }));
  setRowRangeBorders(group_period_sheet, 25, 26, () => ({
    B: { left: "medium", right: "thin" },
    C: { left: "thin", right: "medium" },
  }));
  setColumnWidths(group_period_sheet, {
    1: 2,
    2: 90,
    3: 90,
    4: 60,
    5: 2,
  });
  setCellAlignments(group_period_sheet, {
    B4: { vertical: "top", horizontal: "left" },
    B35: { vertical: "top", horizontal: "left", wrapText: true },
    B38: { vertical: "top", horizontal: "left", wrapText: true },
  });
  setRowHeights(group_period_sheet, {
    35: 100,
    38: 100,
  });

  const group_Greys = [
    "B7",
    "C7",
    "B9",
    "C9",
    "D9",
    "B11",
    "C11",
    "B15",
    "B18",
    "B24",
    "B33",
    "C33",
    "D33",
    "B37",
    "C37",
    "D37",
    "B40",
    "C40",
    "D40",
    "B46",
    "C46",
    "E48",
  ];
  setCellsFill(group_period_sheet, group_Greys, FILL_COLORS.grey);

  const group_Lemons = [
    "B2",
    "C2",
    "D2",
    "B4",
    "C4",
    "D4",
    "B5",
    "C5",
    "D5",
    "B22",
    "B27",
    "C27",
    "B34",
    "C34",
    "D34",
    "C47",
  ];
  setCellsFill(group_period_sheet, group_Lemons, FILL_COLORS.lemon);

  const group_Golds = [
    "D12",
    "D13",
    "D15",
    "D16",
    "D18",
    "D19",
    "D20",
    "D21",
    "D22",
    "C25",
    "C26",
    "B30",
    "C30",
    "B31",
    "C31",
    "B35",
    "C35",
    "D35",
    "B38",
    "C38",
    "D38",
    "C42",
    "D42",
    "C43",
    "D43",
    "C44",
    "D44",
    "B47",
  ];
  setCellsFill(group_period_sheet, group_Golds, FILL_COLORS.gold);

  const gle_bolds = [
    "B2",
    "B4",
    "B7",
    "B8",
    "B9",
    "B10",
    "B12",
    "B20",
    "B25",
    "B30",
    "B35",
    "C12",
    "D12",
  ];
  setCellsFont(group_level_elections_sheet, gle_bolds, { bold: true });
  mergeRanges(group_level_elections_sheet, [
    "C7:D 7",
    "C8:D8",
    "C9:D9",
    "C10:D10",
  ]);

  setGroupedBorders(group_level_elections_sheet, [
    {
      border: {
        left: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "medium" },
      },
      cells: ["B2", "B4"],
    },
    {
      border: { top: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["C2", "C4"],
    },
    {
      border: {
        right: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "medium" },
      },
      cells: ["D2", "D4"],
    },
    {
      border: {
        left: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "thin" },
      },
      cells: ["B6"],
    },
    {
      border: { top: { style: "medium" }, bottom: { style: "thin" } },
      cells: ["C6"],
    },
    {
      border: {
        right: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "thin" },
      },
      cells: ["D6"],
    },
    {
      border: {
        left: { style: "medium" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
      cells: ["B7", "B8", "B9"],
    },
    {
      border: { right: { style: "medium" }, bottom: { style: "thin" } },
      cells: ["D7", "D8", "D9"],
    },
    {
      border: { bottom: { style: "thin" } },
      cells: ["C7", "C8", "C9"],
    },
    {
      border: {
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "thin" },
      },
      cells: ["B10"],
    },
    {
      border: { bottom: { style: "medium" } },
      cells: ["C10"],
    },
    {
      border: { right: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["D10"],
    },
    {
      border: {
        left: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
      cells: ["B12"],
    },
    {
      border: {
        top: { style: "medium" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
      cells: ["C12"],
    },
    {
      border: {
        right: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "thin" },
      },
      cells: ["D12"],
    },
  ]);
  setRowRangeBorders(group_level_elections_sheet, 13, 18, (row) => ({
    B: {
      left: "medium",
      bottom: row === 18 ? "medium" : "thin",
      right: "thin",
    },
    C: { bottom: row === 18 ? "medium" : "thin", right: "thin" },
    D: { right: "medium", bottom: row === 18 ? "medium" : "thin" },
  }));

  [20, 25, 30].forEach((startRow) => {
    setBorders(group_level_elections_sheet, {
      [`B${startRow}`]: { left: "medium", top: "medium" },
      [`C${startRow}`]: { top: "medium" },
      [`D${startRow}`]: { right: "medium", top: "medium" },
      [`B${startRow + 1}`]: { left: "medium" },
      [`D${startRow + 1}`]: { right: "medium" },
      [`B${startRow + 2}`]: { left: "medium", bottom: "thin" },
      [`C${startRow + 2}`]: { bottom: "thin" },
      [`D${startRow + 2}`]: { right: "medium", bottom: "thin" },
      [`B${startRow + 3}`]: { left: "medium", bottom: "medium" },
      [`C${startRow + 3}`]: { bottom: "medium" },
      [`D${startRow + 3}`]: { right: "medium", bottom: "medium" },
    });
  });

  setGroupedBorders(group_level_elections_sheet, [
    {
      border: {
        left: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "thin" },
      },
      cells: ["B35"],
    },
    {
      border: {
        right: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "thin" },
      },
      cells: ["C35"],
    },
    {
      border: { left: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["B36"],
    },
    {
      border: { right: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["C36"],
    },
  ]);
  group_level_elections_sheet.getCell("C9").value = {
    formula: "='(1)_Group,_period,_return_type'!D22",
  };

  setColumnWidths(group_level_elections_sheet, {
    1: 2,
    2: 165,
    3: 20,
    4: 20,
    5: 2,
  });
  setRowHeights(group_level_elections_sheet, {
    23: 80,
    28: 80,
    33: 80,
  });

  setCellAlignments(group_level_elections_sheet, {
    B23: { vertical: "top", horizontal: "left" },
    B28: { vertical: "top", horizontal: "left" },
    B33: { vertical: "top", horizontal: "left", wrapText: true },
    C13: { horizontal: "center" },
    C14: { horizontal: "center" },
    C15: { horizontal: "center" },
    C16: { horizontal: "center" },
    C17: { horizontal: "center" },
    C18: { horizontal: "center" },
    D13: { horizontal: "center" },
    D14: { horizontal: "center" },
    D15: { horizontal: "center" },
    D16: { horizontal: "center" },
    D17: { horizontal: "center" },
    D18: { horizontal: "center" },
  });

  const gle_Greys = [
    "B2",
    "C2",
    "D2",
    "B4",
    "C4",
    "D4",
    "B7",
    "B8",
    "B9",
    "B10",
    "B12",
    "B20",
    "B25",
    "B30",
    "B35",
    "C20",
    "D20",
    "C25",
    "D25",
    "C30",
    "D30",
    "C35",
  ];
  setCellsFill(group_level_elections_sheet, gle_Greys, FILL_COLORS.grey);

  const gle_Lemons = ["B6", "C6", "D6", "C36"];
  setCellsFill(group_level_elections_sheet, gle_Lemons, FILL_COLORS.lemon);

  const gle_Golds = [
    "C13",
    "D13",
    "C14",
    "D14",
    "C15",
    "C16",
    "C17",
    "D17",
    "C18",
    "B23",
    "C23",
    "D23",
    "B28",
    "C28",
    "D28",
    "B33",
    "C33",
    "D33",
    "B36",
  ];
  setCellsFill(group_level_elections_sheet, gle_Golds, FILL_COLORS.gold);

  setColumnWidths(uk_group_companies_sheet, {
    1: 2,
    2: 12,
    3: 115,
    4: 35,
    5: 35,
    6: 5,
  });
  setRowHeights(uk_group_companies_sheet, { 11: 7 });

  setGroupedBorders(uk_group_companies_sheet, [
    {
      border: {
        left: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "medium" },
      },
      cells: ["B2", "B4"],
    },
    {
      border: { top: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["C2", "C4"],
    },
    {
      border: {
        top: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      },
      cells: ["D2", "D4"],
    },
    {
      border: {
        left: { style: "medium" },
        top: { style: "medium" },
        bottom: { style: "thin" },
      },
      cells: ["B6"],
    },
    {
      border: { top: { style: "medium" }, bottom: { style: "thin" } },
      cells: ["C6"],
    },
    {
      border: {
        top: { style: "medium" },
        bottom: { style: "thin" },
        right: { style: "medium" },
      },
      cells: ["D6"],
    },
    {
      border: {
        left: { style: "medium" },
        bottom: { style: "thin" },
        right: { style: "medium" },
      },
      cells: ["B7", "B8", "B9"],
    },
    {
      border: { top: { style: "thin" }, bottom: { style: "thin" } },
      cells: ["C7", "C8", "C9", "C10"],
    },
    {
      border: { right: { style: "medium" }, bottom: { style: "thin" } },
      cells: ["D7"],
    },
    {
      border: {
        right: { style: "medium" },
        bottom: { style: "thin" },
        top: { style: "thin" },
      },
      cells: ["D8", "D9", "D10"],
    },
    {
      border: {
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      },
      cells: ["B10"],
    },
    {
      border: { left: { style: "medium" }, top: { style: "medium" } },
      cells: ["B12"],
    },
    { border: { top: { style: "medium" } }, cells: ["C12", "D12"] },
    {
      border: {
        top: { style: "medium" },
        right: { style: "medium" },
        bottom: { style: "medium" },
        left: { style: "medium" },
      },
      cells: ["E12"],
    },
    {
      border: { left: { style: "medium" }, bottom: { style: "thin" } },
      cells: ["B13"],
    },
    { border: { bottom: { style: "thin" } }, cells: ["C13"] },
    {
      border: { bottom: { style: "thin" }, right: { style: "medium" } },
      cells: ["D13"],
    },
    {
      border: {
        bottom: { style: "thin" },
        right: { style: "medium" },
        left: { style: "medium" },
      },
      cells: ["E13", "E14"],
    },
    {
      border: { left: { style: "medium" }, right: { style: "thin" } },
      cells: ["B14"],
    },
    {
      border: { bottom: { style: "thin" }, right: { style: "thin" } },
      cells: ["C14", "D14"],
    },
  ]);
  uk_group_companies_sheet.getCell("D9").value = {
    formula: "='(1)_Group,_period,_return_type'!D22",
  };

  setRowRangeBorders(uk_group_companies_sheet, 15, 315, () => ({
    B: { left: "medium", bottom: "thin", right: "thin" },
    C: { bottom: "thin", right: "thin" },
    D: { bottom: "thin", right: "medium" },
    E: { bottom: "thin", right: "medium", left: "medium" },
  }));

  setGroupedBorders(uk_group_companies_sheet, [
    {
      border: {
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "thin" },
      },
      cells: ["B315"],
    },
    {
      border: { bottom: { style: "medium" }, right: { style: "thin" } },
      cells: ["C315"],
    },
    {
      border: { bottom: { style: "medium" }, right: { style: "medium" } },
      cells: ["D315", "E315"],
    },
    {
      border: { left: { style: "medium" }, top: { style: "medium" } },
      cells: ["C317"],
    },
    {
      border: { right: { style: "medium" }, top: { style: "medium" } },
      cells: ["D317"],
    },
    {
      border: { left: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["C318"],
    },
    {
      border: { right: { style: "medium" }, bottom: { style: "medium" } },
      cells: ["D318"],
    },
  ]);

  setCellAlignments(
    uk_group_companies_sheet,
    Object.fromEntries(
      buildColumnRowRangeCells(["B", "D", "E"], 14, 315).map((cell) => [
        cell,
        { horizontal: "center" },
      ]),
    ),
  );

  const ugc_bolds = [
    "B2",
    "B4",
    "B7",
    "B8",
    "B9",
    "B10",
    "C12",
    "C14",
    "D14",
    "E14",
    "F14",
    "D15",
    "E15",
    "F15",
    "H12",
    "H13",
    "H14",
    "I14",
    "J14",
    "C320",
    "H317",
    "H318",
    "I318",
    "H321",
    "I321",
    "J321",
  ];
  setCellsFont(uk_group_companies_sheet, ugc_bolds, { bold: true });

  uk_group_companies_sheet.getCell("C12").font = { italic: true };

  const ugc_Greys = [
    "B2",
    "C2",
    "D2",
    "B4",
    "C4",
    "D4",
    "B7",
    "C7",
    "B8",
    "C8",
    "B9",
    "C9",
    "B10",
    "C10",
    "B12",
    "C12",
    "D12",
    "E12",
    "B13",
    "C13",
    "D13",
    "E13",
    "C317",
    "D317",
  ];
  setCellsFill(uk_group_companies_sheet, ugc_Greys, FILL_COLORS.grey);

  const buildGoldsList = buildColumnRowRangeCells(["C", "D", "E"], 16, 315);
  const ugc_Lemons = ["B6", "C6", "D6", "C15", "D15", "E15", "D318"];
  setCellsFill(uk_group_companies_sheet, ugc_Lemons, FILL_COLORS.lemon);

  const ugc_Golds_others = ["C318"];
  const ugc_Golds = ugc_Golds_others.concat(buildGoldsList);
  setCellsFill(uk_group_companies_sheet, ugc_Golds, FILL_COLORS.gold);

  return [
    group_period_sheet,
    group_level_elections_sheet,
    uk_group_companies_sheet,
  ];
}
